import { observable } from "mobx";

import SignupOptions from "../Pages/SignupOptions";
import SignupWithEmail from "../Pages/SignupWithEmail";
import SignupZipcode from "../Pages/SignupZipcode";

import Signup from "../@libs/Signup";
import Zipcode from "../@libs/Zipcode";
import Service from "../@libs/Service";

class ProSignupFunnelStore {
	@observable signupWithEmail = false;

	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;

		this.Service = new Service(rootStore);
		this.Zipcode = new Zipcode(rootStore, staticContext);
		this.Signup = new Signup(rootStore);
	}

	get Component() {
		if (!this.Zipcode.value) return SignupZipcode;
		if (this.signupWithEmail) return SignupWithEmail;
		return SignupOptions;
	}
}

export default ProSignupFunnelStore;
